import { AUCTION_TYPES } from 'constants';
import { Vehicle } from 'types/vehicle';

export const useIsAlternativeAuction = (vehicle?: Vehicle) => {
  if (!vehicle || !vehicle.auction) {
    return false;
  }

  return vehicle.auction.type !== AUCTION_TYPES.AUTOAXESS;
};
